// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2Idhy","dragIcon":"Choice_dragIcon__YcXFa","left":"Choice_left__1FAN_","input":"Choice_input__1mLUy"};